module.exports = __webpack_public_path__ + "static/img/9.bbc4fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/9.png
// module id = yDG5
// module chunks = 35